/* eslint-disable jsx-a11y/click-events-have-key-events, react/jsx-curly-brace-presence */

import { withStyles } from '@material-ui/core/styles'
import styled, { css } from 'styled-components'

import theme from '../../utils/theme'
import Icon from '../Icon'

const styles = () => ({})

function StatusLabel(props) {
  const { icon, iconRight, iconSize, iconColor, label, preText, textAfter, variant, ...rest } = props

  return (
    <>
      <StatusWrap variant={variant} {...rest}>
        {preText && (
          <PreText>
            {preText}
            {':'}
          </PreText>
        )}
        <StatusWrapInner iconRight={iconRight}>
          {icon && (
            <IconWrap iconRight={iconRight} iconColor={iconColor}>
              <Icon iconName={icon} iconSize={iconSize} />
            </IconWrap>
          )}
          <Label>{label}</Label>
        </StatusWrapInner>
      </StatusWrap>
      {textAfter && <TextAfter>{textAfter}</TextAfter>}
    </>
  )
}

StatusLabel.defaultProps = {
  iconSize: 16,
  preText: '',
  textAfter: '',
  variant: 'default',
}

const StatusWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 66px;
  min-height: 20px;
  padding: 0 8px;
  margin: 0 16px 0 0;
  font-size: ${theme.typography.fontSizeTinyish};
  font-weight: ${theme.typography.fontWeightBolder};
  color: #fff;
  border-radius: 4px;
  color: ${props => theme.statusLabel.color[props.variant] || theme.statusLabel.color.default};
  background-color: ${props => theme.statusLabel.bgColor[props.variant] || theme.statusLabel.bgColor.default};
  border: ${props => (props.variant === 'info' ? `1px solid ${theme.colors.border}` : 'none')};

  ${props =>
    props.variant === 'new' &&
    css`
      margin-left: 0.625rem;
      text-transform: uppercase;
      min-width: 36px;
  `}

  span {
    line-height: 1;
    transform: translateY(-0.5px);
  }
`

const StatusWrapInner = styled.span`
  display: flex;
  flex-direction: ${props => (props.iconRight ? 'row-reverse' : 'row')};
  align-items: center;
`

const IconWrap = styled.span`
  color: ${props =>
    props.iconColor ? theme.statusLabel.bgColor[props.iconColor] || theme.statusLabel.color.default : 'inherit'};
  margin: ${props => (props.iconRight ? '0 -2px 0 6px' : '0 6px 0 -2px')};

  svg {
    display: block;
  }
`

const Label = styled.span`
  font-weight: 500;
`

const PreText = styled.span`
  display: inline-block;
  margin: 0 8px 0 0;
`

const TextAfter = styled.span`
  font-size: 0.875rem;
  color: ${`var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`};
`

const StatusLabelComponent = withStyles(styles)(StatusLabel)
StatusLabelComponent.displayName = 'StatusLabel'
export default StatusLabelComponent
